import { db } from '../firebase';
import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';

// ═══════════════════════════════════════════════════════════════════
//  LIBRARY PAYLOAD — heavy fields (intelligenceJson + scrapedData)
//  pisah dari parent item supaya list query ringan.
//
//  Path: library/{folderId}/items/{itemId}/payload/data
//
//  Parent item simpan flag `hasIntelligence` + `hasScrapedData` (optional)
//  + metadata ringan (name, number, price, dll). Heavy field lazy-load
//  bila modal/copy-to-workspace buka.
// ═══════════════════════════════════════════════════════════════════

const payloadDocRef = (folderId, itemId) =>
    doc(db, 'library', folderId, 'items', itemId, 'payload', 'data');

// Load payload — return { intelligenceJson, scrapedData } atau null kalau takda.
// Backward-compat: caller patut fall back ke parent.intelligenceJson kalau
// payload subdoc takda (item belum migrate).
export async function loadLibraryPayload(folderId, itemId) {
    if (!folderId || !itemId) return null;
    try {
        const snap = await getDoc(payloadDocRef(folderId, itemId));
        return snap.exists() ? snap.data() : null;
    } catch (err) {
        console.error('[libraryPayload] load error:', folderId, itemId, err);
        return null;
    }
}

// Save payload — merge mode supaya boleh update sebahagian field.
export async function saveLibraryPayload(folderId, itemId, { intelligenceJson, scrapedData, updatedBy }) {
    const data = { updatedAt: serverTimestamp() };
    if (intelligenceJson !== undefined) data.intelligenceJson = intelligenceJson;
    if (scrapedData !== undefined) data.scrapedData = scrapedData;
    if (updatedBy) data.updatedBy = updatedBy;
    await setDoc(payloadDocRef(folderId, itemId), data, { merge: true });
}

// Delete payload — guna bila parent item dipadam.
export async function deleteLibraryPayload(folderId, itemId) {
    try {
        await deleteDoc(payloadDocRef(folderId, itemId));
    } catch (err) {
        // Idempotent — silent kalau dah takda
        console.warn('[libraryPayload] delete (ignored):', err?.message);
    }
}

